class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    setTimeout(this.checkFreeGiftEligibility.bind(this), 500);
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
     // console.log('event.target.type', event.target.type);
    if(event.target.type == 'number')
    {
      this.validateQuantity(event);
    }
    
  }


  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    // Added free gift logic to "add item" changes, runs after a second of delay
    setTimeout(this.checkFreeGiftEligibility.bind(this), 1000);
  }


  // =============== START FREE GIFT LOGIC ===============

  hasRequiredDiscount(cart) {
    const requiredCode = 'bfearlyaccess';
    const matchesCode = (value) => typeof value === 'string' && value.toLowerCase() === requiredCode;

    if (Array.isArray(cart.cart_level_discount_applications)) {
      const foundCartLevel = cart.cart_level_discount_applications.some(
        (discount) => matchesCode(discount?.title) || matchesCode(discount?.code)
      );
      if (foundCartLevel) return true;
    }

    if (Array.isArray(cart.items)) {
      for (const item of cart.items) {
        if (Array.isArray(item.discount_allocations)) {
          const foundAllocation = item.discount_allocations.some((alloc) =>
            matchesCode(alloc?.discount_application?.title) || matchesCode(alloc?.discount_application?.code)
          );
          if (foundAllocation) return true;
        }
        if (Array.isArray(item.discounts)) {
          const foundLine = item.discounts.some((discount) => matchesCode(discount?.title) || matchesCode(discount?.code));
          if (foundLine) return true;
        }
      }
    }

    return false;
  }

  getFreeGiftVariantId(cartItems = []) {
    const storedVariantId = Number(localStorage.getItem('selectedGiftVariantId'));
    if (!Number.isNaN(storedVariantId) && storedVariantId > 0) {
      return storedVariantId;
    }

    if (window.ShopifySettings?.freeGiftVariantId) {
      return Number(window.ShopifySettings.freeGiftVariantId);
    }

    if (window.ShopifySettings?.freeGiftProductId && cartItems.length) {
      const giftLine = cartItems.find((item) => item.product_id === Number(window.ShopifySettings.freeGiftProductId));
      if (giftLine) {
        return giftLine.variant_id;
      }
    }

    return null;
  }

  // Check if the cart meets the free gift goal
  checkFreeGiftEligibility() {
    if (window.ShopifySettings) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const freeGiftGoal = Number(window.ShopifySettings.freeGiftGoal);
          if (!freeGiftGoal || Number.isNaN(freeGiftGoal)) {
            return;
          }

          const hasDiscount = this.hasRequiredDiscount(cart);
          const giftVariantId = this.getFreeGiftVariantId(cart.items);
          if (giftVariantId && !localStorage.getItem('selectedGiftVariantId')) {
            localStorage.setItem('selectedGiftVariantId', giftVariantId);
          }

          var totalValue = cart.total_price / 100; // Shopify provides price in cents, so divide by 100 to get the dollar amount.
          const freeGiftInCart = giftVariantId ? this.isFreeGiftInCart(cart.items, giftVariantId) : false;
  
          if (freeGiftInCart) {
            const giftLine = cart.items.find(item => item.variant_id === giftVariantId);
            if (giftLine) {
              totalValue -= giftLine.price / 100;
            }
          }
      
          if (hasDiscount && totalValue >= freeGiftGoal && !freeGiftInCart && giftVariantId) {
            this.showFreeGiftModal(giftVariantId);
          } else if ((!hasDiscount || totalValue < freeGiftGoal) && freeGiftInCart) {
            this.removeFreeGiftFromCart(cart.items, giftVariantId);
          } else if (!hasDiscount || totalValue < freeGiftGoal) {
            // Allow the modal to display again to those that declined after the total falls below the goal.
            localStorage.setItem('giftDeclined', 'false');
          }
        });
    }
  }

  // Check if the free gift is already in the cart
  isFreeGiftInCart(cartItems, variantId) {
    const targetVariantId = variantId || this.getFreeGiftVariantId(cartItems);
    if (!targetVariantId) return false;
    return cartItems.some(item => item.variant_id === targetVariantId);
  }

  // Show the modal with the free gift offer
  showFreeGiftModal(giftVariantId) {
    this.addFreeGiftToCart(giftVariantId);
  }

  addFreeGiftToCart(giftVariantId) {
    if (window.freeGiftUpdateInProgress) return;

    const variantId = giftVariantId || this.getFreeGiftVariantId();
    if (!variantId) return;

    window.freeGiftUpdateInProgress = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        localStorage.setItem('selectedGiftVariantId', variantId);
        localStorage.setItem('giftDeclined', 'false');

        $.get('/cart', (data) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          if (window.location.pathname === '/cart') {
            const cartSelector = doc.querySelector('main');
            $('main').replaceWith(cartSelector);
          }
          const cartDrawerSelector = doc.querySelector("div[class='cart-drawer']");
          $("div[class='cart-drawer']").replaceWith(cartDrawerSelector);
        });
      })
      .catch((error) => console.error('Error adding free gift to cart:', error))
      .finally(() => {
        window.freeGiftUpdateInProgress = false;
      });
  }

  // Remove the free gift from the cart
  removeFreeGiftFromCart(cartItems, giftVariantId) {
    if (window.freeGiftUpdateInProgress) return;

    const variantId = giftVariantId || this.getFreeGiftVariantId(cartItems);
    if (!variantId) return;

    window.freeGiftUpdateInProgress = true;

    let updates = {
      [variantId]: 0
    };
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .then(data => {
        $.get("/cart", function (data) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          if (window.location.pathname === '/cart') {
            const cartSelector = doc.querySelector("main");
            $("main").replaceWith(cartSelector);
          }
          const cartDrawerSelector = doc.querySelector("div[class='cart-drawer']");
          $("div[class='cart-drawer']").replaceWith(cartDrawerSelector);
        });
      })
      .catch(error => console.error('Error removing free gift from cart:', error))
      .finally(() => {
        window.freeGiftUpdateInProgress = false;
      });
  }

  // =============== END FREE GIFT LOGIC ===============
  

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });

    // Added free gift logic to "remove item" changes, runs after a second of delay
    setTimeout(this.checkFreeGiftEligibility.bind(this), 1000);
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
